import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function Disclaimer(_props) {
	return (
		<Trans i18nKey="loan_agreement.disclaimer">
			<p className="justify">
				<i>
					{' '}
					Disclaimer: LendAmi is not a lender. LendAmi does not match lenders with borrowers. LendAmi is a
					platform that allows two parties that already know each other to negotiate their own loan terms
					including loan amount, interest rate and repayment schedule and then track that loan together. Since
					LendAmi is not party to any loans transacted on its platform, LendAmi is not involved in choosing,
					approving or agreeing to loan terms. LendAmi does not run credit checks, enforce the payment of
					loans from one party to another or report to credit bureaus. The LendAmi platform allows users to
					track loans between Php 1,000.00 and Php 250,000.00. Users choose and agree to their own interest
					rate within their local guidelines and determine the length of the loan. LendAmi allows users to
					choose payment schedules that are weekly, bi-weekly, monthly or lump sum with no restrictions on
					loan length. Users will be able to view an amortization schedule showing the total cost of the loan.
					An example loan in the amount of Php 10,000.00 payable in monthly installments over a 3-month period
					at monthly add-on rate of 2% interest will cost the borrower a total of Php 10,636.00 including
					interest and platform fees. Users must be 18 years of age or older to use LendAmi.{' '}
				</i>
			</p>
		</Trans>
	);
}

export default hot(module)(withTranslation()(Disclaimer));
